import React, { Component } from "react";
import { Row } from "react-bootstrap";
import Actions from "./Actions";
import Pitch from "./Pitch";
import noCandidatesIcon from "../../../../../assets/images/empty-project.svg";
import styles from "./Candidates.scss";
import moment from "moment";

class Candidates extends Component {
  static defaultProps = {
    candidates: []
  };

  constructor(props) {
    super(props);

    this.state = {
      hideDeclined: false,
      pitches: []
    };

    this.sortCandidates = this.sortCandidates.bind(this);
  }

  componentDidMount() {
    let { pitches } = this.props;

    pitches.sort(
      (a, b) => moment(b.match.updated_at) - moment(a.match.updated_at)
    );

    this.setState({
      ...this.state,
      pitches
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.pitches !== nextProps.pitches) {
      const hideDeclined =
        nextProps.pitches.filter(pitch =>
          this.isCandidateNotDeclined(pitch.accepted)
        ).length > 0;

      this.setState(
        {
          ...this.state,
          pitches: nextProps.pitches,
          hideDeclined
        },
        () => this.sortCandidates(this.props.sortedBy)
      );
    }
  }

  hideDeclined = hideDeclined => {
    this.setState({
      ...this.state,
      hideDeclined
    });
  };

  sortCandidates(sortBy) {
    const { pitches } = this.state;

    let sorted = pitches;

    switch (sortBy) {
      case "date_pitched":
        sorted = pitches.sort(
          (a, b) => moment(b.match.updated_at) - moment(a.match.updated_at)
        );
        break;
      case "name":
        sorted = pitches.sort((a, b) => {
          let A = a.match.member.first_name.toUpperCase();
          let B = b.match.member.first_name.toUpperCase();
          return A < B ? -1 : A > B ? 1 : 0;
        });
        break;
      case "skills_matched":
        sorted = pitches.sort(
          (a, b) => a.matched_on.length < b.matched_on.length
        );
        break;
    }

    this.setState({
      ...this.state,
      pitches: sorted
    });

    this.props.sortCandidates(sortBy);
  }

  isCandidateNotDeclined(accepted) {
    return _.isNull(accepted) || _.isUndefined(accepted);
  }

  renderCandidates(candidates) {
    const { sortedBy, declineCandidate, undoDecline } = this.props;
    const { hideDeclined } = this.state;

    return (
      <React.Fragment>
        <h2 className={styles.pageTitle}>Candidates</h2>
        <p className={styles.pageSubTitle}>
          Here you’ll find pitches from candidates who met your skill
          requirements and who are interested in your project. Reject candidates
          who don’t fit your project, or start a conversation to request a
          proposal.
        </p>

        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Row>
          <Actions
            hideDeclined={hideDeclined}
            sortedBy={sortedBy}
            onHideDeclined={this.hideDeclined}
            onSort={this.sortCandidates}
          />
        </Row>

        {candidates.map(pitch => {
          const accepted = pitch.accepted;
          return (
            (!hideDeclined || this.isCandidateNotDeclined(accepted)) && (
              <Row key={pitch.match.member_id} className={styles.pitch}>
                <Pitch
                  {...pitch}
                  onDecline={declineCandidate}
                  onUndo={undoDecline}
                />
              </Row>
            )
          );
        })}
      </React.Fragment>
    );
  }

  renderDisabledMessage() {
    return (
      <div className={styles.noCandidates}>
        <div className={styles.noCandidatesMsg}>
          <img
            src={noCandidatesIcon}
            alt="noCandidatesIcon"
            className={styles.noCandidatesIcon}
          />
          <div className={styles.noCandidatesMsgText}>
            No one has pitched for your project yet. <br />
            We will email you when you receive new pitches.
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { pitches } = this.state;

    const candidates = pitches.filter(pitch => !pitch.accepted);

    return (
      <div className={styles.candidates}>
        <div className={styles.content}>
          {candidates.length
            ? this.renderCandidates(candidates)
            : this.renderDisabledMessage()}
        </div>
      </div>
    );
  }
}

export default Candidates;



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/components/candidates/Candidates.js